import '../scss/app.scss';

const $ = jQuery;

// Sliding panel
$(document).ready(function() {
	$('.sliding-panel-button,.sliding-panel-fade-screen,.sliding-panel-close').on('click touchstart',function (e) {
		$('.sliding-panel-content,.sliding-panel-fade-screen').toggleClass('is-visible');
		e.preventDefault();
	});

	$('.sliding-panel-content li.menu-item-has-children > a').click(function (e) {
	e.preventDefault();
	if ($(this).hasClass('open')) {
		$(this).removeClass('open');
		$(this).parent().find('.sub-menu').removeClass('open');
	} else {
		$(this).addClass('open');
		$(this).parent().find('.sub-menu').addClass('open');
		}
	});
});

// Tabs
$(document).ready(function () {
	$('.accordion-tabs').each(function(index) {
		$(this).children('li').first().children('a').addClass('is-active').next().addClass('is-open').show();
	});
	$('.accordion-tabs').on('click', 'li > a.tab-link', function(event) {
		if (!$(this).hasClass('is-active')) {
			event.preventDefault();
			var accordionTabs = $(this).closest('.accordion-tabs');
			accordionTabs.find('.is-open').removeClass('is-open').hide();

			$(this).next().toggleClass('is-open').toggle();
			accordionTabs.find('.is-active').removeClass('is-active');
			$(this).addClass('is-active');
		} else {
			event.preventDefault();
		}
	});
});

// Attorneys
$(document).ready(function () {
	$('.attorneys-terms a').click(function(e) {
		e.preventDefault();
		const category = $(this).data('category');
		if (category === 'all') {
			$('.attorneys-terms li').removeClass('active');
			$('.attorneys-item').fadeIn();
			$(this).parent('li').addClass('active');
		} else {
			$('.attorneys-terms li').removeClass('active');
			$(this).parent('li').addClass('active');
			if ($('.attorneys-terms li.active').length === 0) {
				$('.attorneys-terms a[data-category="all"]').parent('li').addClass('active');
			} else {
				$('.attorneys-terms a[data-category="all"]').parent('li').removeClass('active');
			}

			const selectedCategories = [];
			$('.attorneys-terms li.active').each(function() {
				selectedCategories.push($(this).find('a').data('category'));
			});
			$('.attorneys-item').each(function() {
				let hasClass = false;
				selectedCategories.forEach((c) => {
					if (c === 'all') {
						hasClass = true;
					}
					if ($(this).hasClass(c)) {
						hasClass = true;
					}
				});
				if (hasClass) {
					$(this).fadeIn();
				} else {
					$(this).fadeOut();
				}
			});
		}
	})
});

// News Slider
$(document).ready(function() {
	$('.news-slider').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
		responsive: [
		  {
		    breakpoint: 1300,
		    settings: {
		      slidesToShow: 4,
		      slidesToScroll: 1,
		    }
		  },
		  {
		    breakpoint: 1100,
		    settings: {
		      slidesToShow: 3,
		      slidesToScroll: 1,
		    }
		  },
		  {
		    breakpoint: 800,
		    settings: {
		      slidesToShow: 2,
		      slidesToScroll: 1
		    }
		  },
		  {
		    breakpoint: 500,
		    settings: {
		      slidesToShow: 1,
		      slidesToScroll: 1
		    }
		  }
		  // You can unslick at a given breakpoint now by adding:
		  // settings: "unslick"
		  // instead of a settings object
		]
	});
});

$('.social-header .search a').click(function(e) {
	e.preventDefault();
	const el = $('.top-search-form-container');
	if (el.hasClass('open')) {
		el.removeClass('open');
		el.slideUp(200);
	} else {
		el.addClass('open');
		el.slideDown(200, () => {
			$('.top-search-form-container input.search-field:first').focus();
		});
	}
});



// WEBPACK FOOTER //
// ./src/js/app.js